import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { computed, ref } from 'vue'
import request from '@/utils/request'
import { AxiosPagination } from '@/typings/common'
import AuditCouponModal from './modal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const tableRef = ref()
const searchFrom = ref({ reviewStatus: 1 })
const selectedRows = ref<any[]>([])
const onSelectChange = (selectedRowKeys: string[], rows: any[]) => {
  selectedRows.value = rows
}

const success = () => {
  tableRef.value?.fetch()
}

const statusEnum = [
  { value: undefined, label: '全部' },
  { value: 1, label: '待审核', name: '待审核', color: '#1d4cd2' },
  { value: 2, label: '已通过', name: '已通过', color: '#3FAC46' },
  { value: 3, label: '已驳回', name: '已驳回', color: '#DF443B' }
]

const couponStatusEnum = [
  { value: 0, label: '失败' },
  { value: 1, label: '成功' }
]

const auditCouponRef = ref()
const handleAuditCoupon = () => {
  auditCouponRef.value.toggle(selectedRows.value)
}

const fetch = (searchFrom: any, callBack: (res: any) => void) => {
  const params = searchFrom // 处理客户名称和客户编码的批量查询参数
  request.post<AxiosPagination<any>>('/lbu/api/coupons/page', params).then((res) => {
    callBack(res)
  })
}

const columns = computed(() => [
  { title: '客户名称', dataIndex: 'customerName', width: 200 },
  { title: '客户代码', dataIndex: 'tmsCode' },
  { title: '客户识别码', dataIndex: 'customerSerial' },
  { title: '申请人', dataIndex: 'applicantName' },
  { title: '申请时间', dataIndex: 'applyTime' },
  { title: '申请原因', dataIndex: 'reason' },
  { title: '审核人', dataIndex: 'reviewerName' },
  { title: '审核时间', dataIndex: 'reviewTime' },
  { title: '审核状态', dataIndex: 'reviewStatus' },
  { title: '审核意见', dataIndex: 'reviewComments' },
  { title: '营销活动', dataIndex: 'actName' },
  { title: '发券状态', dataIndex: 'couponStatus' },
  { title: '操作', dataIndex: 'action', width: 200, fixed: 'right' }
])

const handleQueryChange = () => {
  tableRef.value?.search()
}

const auditRow = (row: any) => {
  auditCouponRef.value.toggle([row])
}

return (_ctx: any,_cache: any) => {
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_cos_range_picker = _resolveComponent("cos-range-picker")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_MoreButton = _resolveComponent("MoreButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            rowKey: "id",
            columns: columns.value,
            "row-selection": { onChange: onSelectChange },
            search: searchFrom.value,
            "onUpdate:search": _cache[11] || (_cache[11] = ($event: any) => ((searchFrom).value = $event)),
            onFetch: fetch,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "lbuCouponsAuditRecord"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: searchFrom.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "审核状态" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_radio_group, {
                        value: searchFrom.value.reviewStatus,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchFrom.value.reviewStatus) = $event)),
                        optionType: "button",
                        options: statusEnum,
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (handleQueryChange()))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "customerName",
                    label: "客户名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.customerName,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((searchFrom.value.customerName) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "审核人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        permission: "",
                        value: searchFrom.value.reviewer,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((searchFrom.value.reviewer) = $event)),
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "审核时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: searchFrom.value.reviewStartTime,
                        "onUpdate:startTime": _cache[4] || (_cache[4] = ($event: any) => ((searchFrom.value.reviewStartTime) = $event)),
                        endTime: searchFrom.value.reviewEndTime,
                        "onUpdate:endTime": _cache[5] || (_cache[5] = ($event: any) => ((searchFrom.value.reviewEndTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "申请人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UserSelect, {
                        permission: "",
                        value: searchFrom.value.applicant,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((searchFrom.value.applicant) = $event)),
                        allowClear: ""
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "申请时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_cos_range_picker, {
                        startTime: searchFrom.value.applyStartTime,
                        "onUpdate:startTime": _cache[7] || (_cache[7] = ($event: any) => ((searchFrom.value.applyStartTime) = $event)),
                        endTime: searchFrom.value.applyEndTime,
                        "onUpdate:endTime": _cache[8] || (_cache[8] = ($event: any) => ((searchFrom.value.applyEndTime) = $event))
                      }, null, 8, ["startTime", "endTime"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "tmsCode",
                    label: "客户代码"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.tmsCode,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((searchFrom.value.tmsCode) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "customerSerial",
                    label: "客户识别码"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.customerSerial,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((searchFrom.value.customerSerial) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: handleAuditCoupon
              }, {
                default: _withCtx(() => [
                  _createTextVNode("批量审核")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_batch_coupons_audit_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'couponStatus')
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(couponStatusEnum.find((item) => item.value === text)?.label || '--') + _toDisplayString(record.couponFailedReason ? `(${record.couponFailedReason})` : ''), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'reviewStatus')
                ? (_openBlock(), _createBlock(_component_dc_status, {
                    key: 1,
                    enums: statusEnum,
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_MoreButton, { key: 2 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        disabled: record.reviewStatus !== 1,
                        onClick: ($event: any) => (auditRow(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 审核 ")
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"])), [
                        [_directive_permission, 'lbu_coupon_audit_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "row-selection", "search"]),
          _createVNode(AuditCouponModal, {
            ref_key: "auditCouponRef",
            ref: auditCouponRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})